import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

// Service
import { GroupInsertService } from '../../service/group-insert/group-insert.service';

@Component({
	selector: 'app-group-insert',
	templateUrl: './group-insert.component.html',
	providers: [
		GroupInsertService,
		HttpModule
	]
})
export class GroupInsertComponent implements OnInit {

	private token;
	public form: FormGroup;
	public Ativo: boolean;
	public masterPermissions: any[] = [];
	public masterPermissionsChecked: any[] = [];
	public permissoes: any[] = [];

	constructor(private fb: FormBuilder, private router: Router, private groupInsertService: GroupInsertService, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.form = this.fb.group({
			Nome: ['', Validators.compose([
				Validators.minLength(2),
				Validators.maxLength(100),
				Validators.required
			])],
			Permissao: [this.masterPermissions[0], Validators.required],
			Ativo: [true, Validators.required]
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.groupInsertService.searchPermissions(this.token).subscribe(result => {
			this.masterPermissions = result.Result;
			this.masterPermissionsChecked = [];

			if (result.Success == true) {
				for (var i = this.masterPermissions.length - 1; i >= 0; i--) {

					for (var j = this.masterPermissionsChecked.length - 1; j >= 0; j--) {
						if (this.masterPermissions[i].Nome == this.masterPermissionsChecked[j].Nome) {
							this.masterPermissions[i].checked = true;
						}
					}
				}
			}
		}, error => {
			console.log(error);

		});
	}

	processesList() {

		if (!this.masterPermissions) return [];

		var processes = this.masterPermissions.map(p => p.Processo);
		var uniqueProcesses = processes.filter((x, i, a) => x && a.indexOf(x) === i);

		return uniqueProcesses;

	}

	permissionsByProcess(process) {

		var permissions = this.masterPermissions.filter(mp => mp.Processo == process);
		return permissions;

	}

	addGroup(value: any) {

		var objGroup = {
			Nome: value.Nome,
			Ativo: value.Ativo,
			Permissoes: []
		};

		var ListGroups = this.masterPermissions.filter(opt => opt.checked).map(opt => opt.Nome);
		for (let obj of ListGroups) {
			objGroup.Permissoes.push({ Nome: obj.toString(), Ativo: true })
		}

		this.groupInsertService.insertGroup(this.token, objGroup).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Grupo de Usuário cadastrado com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/grupo-usuario');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/grupo-usuario');
	}

}



// WEBPACK FOOTER //
// ./src/app/group/component/group-insert/group-insert.component.ts